import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { folderService } from 'services';

const ViewModal = (props) => {
    const { show, handleClose, folderId } = props;

    const [viewData, setViewData] = useState('')

    const viewFolder = async () => {
        const response = await folderService.foldereditlist(folderId)
        setViewData(response?.data?.data)

    }
 
    useEffect(() => {
        show && viewFolder()
    }, [show])
    return (
        <>
            <Modal show={show} className="modal-common" onHide={handleClose}>
                <Modal.Header closeButton>Folder Details </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="mb-30">
                            <label className="py-2">Enter Folder Name</label>
                            <p className="form-control rounded-3 bg-cyan w-100">{viewData?.title}</p>
                        </div>
                        <div className="mb-30">
                            <label className="py-2">Google Drive Link</label>
                            <p className="form-control rounded-3 bg-cyan w-100 text-break">{viewData?.link}</p>
                        </div>
                        <div className="mb-30">
                            <label className="py-2"> Password</label>
                            <p className="form-control rounded-3 bg-cyan w-100 word-break">{viewData?.password}</p>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ViewModal
